var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,{tag:"component",staticClass:"oct-menu-item",class:{
    'oct-menu-item--disabled': _vm.disabled
  },attrs:{"role":_vm.role}},[(_vm.$slots.leadingIcon)?_c('span',{staticClass:"oct-menu-item__leading-icon"},[_vm._t("leadingIcon")],2):_vm._e(),_c('span',{staticClass:"oct-menu-item__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }